import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import DashboardPage from './pages/DashboardPage';
import ProblemPage from './pages/ProblemPage';

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-gray-950 text-gray-100">
        <Navbar />
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/problem/:id" element={<ProblemPage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
